import {
  apiGET
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/transactions.ts
import { DATE_FORMATS } from "@repo/utils/constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
var getNetDeposits = async ({
  dateFrom,
  dateTo,
  status = "OK,ACCEPTED_ON_PLATFORM"
}) => {
  const params = {
    created_at_from: dayjs(dateFrom).format(DATE_FORMATS.default),
    created_at_to: dayjs(dateTo).utc().format(DATE_FORMATS.default),
    status
  };
  return await apiGET("/payments/totals", { params });
};
var getSportsTransactions = async (dateFrom, dateTo, page, size, extraParams = {}) => {
  const params = {
    pageNumber: page,
    pageSize: size,
    sort: "createdAt,desc",
    created_at_from: dayjs.utc(dateFrom).format(DATE_FORMATS.default),
    created_at_to: dayjs.utc(dateTo).format(DATE_FORMATS.default),
    ...extraParams
  };
  return await apiGET("/sportsbook/v2/list", { params });
};
var getTransactions = async (transactionType, playerId, dateFrom, dateTo, page, size) => {
  try {
    const transactionTypes = Array.isArray(transactionType) ? transactionType : [transactionType];
    let statuses = "OK,DECLINED,PENDING,ACCEPTED_ON_PLATFORM,DECLINED_ON_PLATFORM,BC_MIGRATION";
    if (transactionTypes.includes("WITHDRAWAL")) {
      statuses += ",CREATED,CANCELED_BY_USER,ON_HOLD";
    }
    const params = {
      type: transactionTypes.join(","),
      pageNumber: page.toString(),
      pageSize: size.toString(),
      sort: "createdAt,desc",
      user_id: playerId,
      created_at_from: dayjs.utc(dateFrom).format(DATE_FORMATS.default),
      created_at_to: dayjs.utc(dateTo).format(DATE_FORMATS.default),
      statuses
    };
    return await apiGET("/payments", { params });
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data
    };
  }
};
var getSessionStats = async () => {
  return await apiGET("/player-session-overview", null, {
    hasNestedData: false
  });
};
var getGameplayStats = async (dateFrom, dateTo) => {
  const params = {
    from: dayjs.utc(dateFrom).format(DATE_FORMATS.default_with_miliseconds),
    to: dayjs.utc(dateTo).format(DATE_FORMATS.default_with_miliseconds)
  };
  return await apiGET(
    "/casino/api/player-stats/totals",
    { params },
    { hasNestedData: false }
  );
};
var getDepositInfo = async () => {
  return await apiGET("/user-activity-fact/deposit-info");
};
var getDepositOptions = async () => {
  return await apiGET("/payments/player/deposit-options/");
};

export {
  getNetDeposits,
  getSportsTransactions,
  getTransactions,
  getSessionStats,
  getGameplayStats,
  getDepositInfo,
  getDepositOptions
};
